















import Vue from 'vue';

export default Vue.extend({
  name: 'check-card',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
    },
    multi: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(event: Event) {
      this.$emit('click', event);
    },
  },
});
